<template>
  <v-row class="justify-center">
    <v-col cols="12">
			<v-row style="padding-bottom: 50px;">
				<v-col
					v-for="(item,index) in categories"
					:key="index"
					class="d-flex child-flex"
					:cols=gridCategories
				>
					<v-card flat tile class="d-flex rounded-card-cat" @click="gotoCartList(item)">
						<v-img
							:src="item.photo_url != '' ? item.photo_url : notImage"
							:lazy-src="item.photo_url != '' ? item.photo_url : notImage"
							aspect-ratio="1"
							class="grey lighten-1 "
							gradient="to top , rgba(0,0,0,.3), rgba(0,0,0,.3)"
						>
							<template v-slot:placeholder>
								<v-row
									class="fill-height ma-0"
									align="center"
									justify="center"
								>

								</v-row>
							</template>
							<v-row align="center" justify="center" class="lightbox white--text pa-2 fill-height">
									<v-col cols="12" >
									<div style="font-size:0.9em; text-align: center;" class="font-weight-bold fonto white--text" v-html="item.nameEN"></div>
									<div style="font-size:0.9em; text-align: center;" class="font-weight-bold fonto white--text" v-html="item.subtitleEN"></div>
									</v-col>
							</v-row>
						</v-img>
					</v-card>
				</v-col>
			</v-row>
    </v-col>
  </v-row>
</template>

<script>
	import { mapState, mapActions } from "vuex";
	import { db } from "@/main";
	export default {
		name: 'Categories',
		mounted(){
			if (this.categories.length == 0){
				const refFeat = db.collection('bussiness')
					.doc(this.$route.params.id).collection('categories')
					.where('visible','==', true)
					.orderBy('order')

				refFeat.onSnapshot(snap => {
					if (snap.empty) {
						console.log('Not matching documents.')
						return
					}
					this.categories = []
					snap.forEach(doc => {
						this.categories.push( {id: doc.id, ...doc.data()} )
					})

				})
			}
		},
		data: () => ({
      businessId: '',
			categories: [],
			notImage: '/static/images/not-found.png',
		}),
		methods: {
			gotoCartList(item){
				this.$store.commit('SET_CATEGORY', item)
				this.$router.push(`/i/${this.$route.params.id}/en/cart/${item.id}`)
			}
		},
		computed: {
			...mapState(['gridCategories','category']),
		}
	}
</script>
<style>
	.rounded-card-cat{
   	border-radius:20px !important;

	}
	.col-12  {
		padding-bottom: 0px !important;
		padding-top: 0px !important;
	}
	.col-sm-6 {
		padding-bottom: 0px !important;
		padding-top: 0px !important;
	}
	.col-4 {
    padding: 6px;
	}
	.col-6 {

		padding: 6px;
		font-size:1.4em !important;
	}
	.fonto {
		font-family:  Roboto, sans-serif;
	}
</style>
